export default "__VITE_ASSET__C09HsMfG__"